import Actions                           from 'Redux/Actions';
import { OrganisationInvoiceRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from }                          from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';

export const findOrganisationInvoicesEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findOrganisationInvoicesRequest.type),
    mergeMap(action => from(
      OrganisationInvoiceRepository.findAll(action.payload)
        .then(({ organisationInvoices, meta }) => Actions.findOrganisationInvoicesSuccess({ organisationInvoices, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findOrganisationInvoicesFailure({ error })),
    )),
  );
};
